import script from "./GlobusRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusRadio.vue?vue&type=script&setup=true&lang=js"

import "./GlobusRadio.vue?vue&type=style&index=0&id=92dc2b12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92dc2b12"]])

export default __exports__